/**
 * Components
 */

import Account from './custom/account/account';
import Login from './custom/login/login';
import GlobalToasts from './custom/system/global-toasts';
import GlobalNote from './custom/global-note/global-note';
import {init as MultiSelect} from "./overwrites/form/elements/multi-select";

// Modules
import User from '../modules/user/user';
import Events from '../modules/events/events';
import Steps from '../modules/steps/steps';

// ------
// Public
// ------

const components = () => {
	Account.init();
	Login.init();
	// Events.init();
	User.init();
	Steps.init();
	GlobalToasts.init();
	GlobalNote.init();
	MultiSelect();
};

// Export
export default components;
